import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Card, CardHeader, CardBody, Alert, Collapse, Button, Label } from 'reactstrap'
import { DataTable, TableRowField, ExportCSV } from '../../../../components'
import { getRegularizations } from '../../../../store/report/actions'
import { layout, roles, messages } from '../../../../common/constants'
import MediaQuery from 'react-responsive'
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { formatHelper } from '../../../../common/helpers'
import { getRegularizations as productMovementExport } from '../../../../service/report'

import { getStores } from '../../../../store/store/actions'
import { selectUserRole } from '../../../../store/user/selector'
import { selectStoresForSelect } from '../../../../store/store/selector'
import Select from 'react-select'


class Regularizations extends Component {

    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            focusedInput: null,
            page: 1,
            productMovementExport: [],
            selectedStore: null,
        }
        this.handleObtainReportExport = this.handleObtainReportExport.bind(this)
        this.handleExportCSV = this.handleExportCSV.bind(this)

        this.handlePageChange = this.handlePageChange.bind(this);

        this.handleStoreChange = this.handleStoreChange.bind(this);

    }

    async handleStoreChange(value) {
        if (value == this.state.selectedStore) return
        await this.setState({ selectedStore: value, page: 1 })

        if (this.state.startDate && this.state.endDate && this.state.selectedStore) {
            this.props.getRegularizations({ page: this.state.pageDetails, startDate: this.state.startDate._d, endDate: this.state.endDate._d, store: this.state.selectedStore.value })
        }
    }

    async componentDidMount() {
        await this.props.getStores({ reset: true })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
            this.setState({ selectedStore: this.props.stores[0] })
        }
    }





    handleRegularizationsDateChange(startDate, endDate) {
        this.setState({ startDate, endDate })

        if (startDate != null && endDate != null) {

            this.props.getRegularizations({ page: this.state.page, startDate: startDate._d, endDate: endDate._d, store: this.state.selectedStore.value })
        }
    }

    performGetRegularizations(reset = false) {
        const { getRegularizations } = this.props
        const { page } = this.state

        getRegularizations({ page, startDate: this.state.startDate._d, endDate: this.state.endDate._d, reset, store: this.state.selectedStore.value })
    }

    async handlePageChange(page) {
        await this.setState({ page: page })
        this.performGetRegularizations();
    }
    renderDataTable(columns) {
        return (
            <DataTable
                data={this.props.regularizations}
                keyField='id'
                columns={columns}
                page={this.state.page}
                totalSize={this.props.total}
                sizePerPage={this.props.pageSize}
                loading={this.props.loading}
                onPageChange={this.handlePageChange}
            />
        )
    }

    async handleObtainReportExport() {
        await productMovementExport(0, this.state.startDate._d, this.state.endDate._d, this.state.selectedStore.value).then(response => {
            this.setState({
                productMovementExport: response.data.data
            })
        })
        this.handleExportCSV()
    }

    handleExportCSV() {
        var csvRow = []
        var A = [['', 'Producto', 'Cantidad', 'Tienda']]
        var re = this.state.productMovementExport
        var storeName = this.state.selectedStore.label

        var totalQuantity = 0

        for (var item = 0; item < re.length; item++) {
            A.push([item + 1, re[item].Product.name, re[item].quantity, re[item].Store.name])
            totalQuantity += re[item].quantity
        }
        A.push(['', 'Total', totalQuantity, ''])

        for (var item = 0; item < A.length; item++) {
            A[item][1] = String(A[item][1]).replace(/\s/g, " ")
            A[item][3] = String(A[item][3]).replace(/\s/g, " ")
            csvRow.push(A[item].join(","))
        }
        var csvString = csvRow.join("\r\n")
        storeName = String(storeName).replace(/\s/g, '_')

        var a = document.createElement("a")
        a.href = 'data:attachment/csv;charset=utf-16le,%EF%BB%BF' + encodeURI(csvString)
        a.target = "_Blank"
        a.download = (this.state.selectedStore.value == 0 ? formatHelper.toDateYYMMDD(new Date().toUTCString()) + "_reporte-general-regularizaciones_" + formatHelper.toDateYYMMDD(this.state.startDate._d) + "_" + formatHelper.toDateYYMMDD(this.state.endDate._d) + ".csv" :
            formatHelper.toDateYYMMDD(new Date().toUTCString()) + "_reporte-productos-regularizaciones_" + storeName.toLowerCase() + "_" + formatHelper.toDateYYMMDD(this.state.startDate._d) + "_" + formatHelper.toDateYYMMDD(this.state.endDate._d) + ".csv")
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    render() {

        const columnsXS = [
            {
                dataField: 'xs',
                text: 'Detalle Regularizaciones',
                formatter: (cell, row) => {
                    return (
                        <div>
                            <TableRowField label='Producto:' value={row.Product.name} />
                            <TableRowField label='Cantidad:' value={row.quantity} />
                            <TableRowField label='Tienda:' value={row.Store.name} />
                        </div>
                    )
                }
            }
        ]
        const columnsSM = [
            {
                dataField: 'xs',
                text: 'Detalle Regularizaciones',
                formatter: (cell, row) => {
                    return (
                        <div>
                            <TableRowField label='Producto:' value={row.Product.name} />
                            <TableRowField label='Cantidad:' value={row.quantity} />
                            <TableRowField label='Tienda:' value={row.Store.name} />
                        </div>
                    )
                }
            }
        ];
        const columnsMD = [
            {
                dataField: 'product',
                text: 'Producto',
                formatter: (cell, row) => {
                    return (
                        <div>
                            <TableRowField label='' value={row.Product.name} />
                        </div>
                    )
                }
            },
            {
                dataField: 'quantity',
                text: 'Cantidad'
            },
            {
                dataField: 'store',
                text: 'Tienda',
                formatter: (cell, row) => {
                    return (
                        <div>
                            <TableRowField label='' value={row.Store.name} />
                        </div>
                    )
                }
            }
        ];
        const { startDate, endDate } = this.state

        return (
            <div>
                <Card>
                    <CardHeader>
                        <i className="icon-chart"></i>Regularizaciones
                    </CardHeader>
                    <CardBody>
                        {(this.props.role == roles.SUPER_ADMIN || this.props.role == roles.ADMIN) && (
                            <Row className="my-4">
                                <Col sm='1'>
                                    <Label className='mt-2' >Tienda:</Label>
                                </Col>

                                <Col sm='4'>

                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isLoading={this.props.loadingStores}
                                        isSearchable={true}
                                        noOptionsMessage={() => { return messages.SELECT_NO_OPTIONS }}
                                        placeholder=''
                                        options={this.props.stores}
                                        loadingMessage={() => { return messages.SELECT_LOADING }}
                                        onChange={this.handleStoreChange}
                                        value={this.state.selectedStore}
                                        isDisabled={this.props.loadingStores}
                                    />


                                </Col>
                            </Row>

                        )}
                        <Row className='mb-2'>
                            <Col md="12">
                                <DateRangePicker
                                    startDate={startDate}
                                    startDateId="startDate"
                                    endDate={endDate}
                                    endDateId="endDate"
                                    displayFormat={'DD/MM/YYYY'}
                                    onDatesChange={({ startDate, endDate }) => this.handleRegularizationsDateChange(startDate, endDate)}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                    startDatePlaceholderText='Fecha Inicio'
                                    endDatePlaceholderText='Fecha Fin'
                                    small
                                    isOutsideRange={() => false}
                                    hideKeyboardShortcutsPanel
                                    minimumNights={0}
                                />
                                {this.state.startDate && this.state.endDate ?
                                    <ExportCSV
                                        exportCSV={this.handleObtainReportExport} />
                                    : null}
                            </Col>
                        </Row>
                        <hr className='my-4' />
                        {
                            (startDate != null && endDate != null)
                                ? (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columnsXS)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columnsSM)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columnsMD)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                                : (
                                    <Row>
                                        <Col>
                                            <Alert color="info">
                                                Seleccione un rango de fechas para visualizar los datos
                                                    </Alert>
                                        </Col>
                                    </Row>
                                )
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}


function mapStateToProps(state) {
    const { regularizations, total, pageSize, error, loading } = state.report.regularizationsList
    return {
        regularizations,
        total,
        pageSize,
        error,
        loading,

        role: selectUserRole(state),
        stores: selectStoresForSelect(state),
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getRegularizations,
        getStores,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Regularizations)




// WEBPACK FOOTER //
// ./src/scenes/Report/StockMovement/Regularizations/Regularizations.js